import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {LoginService} from '@services/login.service';
import {ExternalReferenceService} from '@core/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {

  constructor(
    private loginService: LoginService,
    private router: Router,
    private externalReferenceService: ExternalReferenceService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.loginService.isLoggedIn() && !this.externalReferenceService.isActive()) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
